export default __webpack_public_path__ + "static/media/382.1cc8aafb.png";